// extracted by mini-css-extract-plugin
export default {"numberOfRequests":"listItems_numberOfRequests__++xDR"};